import * as ng from 'angular';

ng.module('e360').directive('expList', expListDirectiveFactory);

export function expListDirectiveFactory():ng.IDirective {
   return {
      restrict: 'E',
      scope: {
         data: '='
      },
      link: function(scope, element) {
         element.attr('class', 'exp-list');
      },
      bindToController: true,
      controller: function() { }
   };
}

export interface IExpListDirectiveController {
   data:any[];
}
